module.exports = __webpack_public_path__ + "img/arrow_up_icon.85ef088a.svg";